import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, TimeoutError, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

// import { StorageServiceService } from './services/storage.service';
import { environment } from 'src/environments/environment';



@Injectable()
export class AppInterceptor implements HttpInterceptor {
    private debug:boolean = true;
    /**
     * Constructor
     */
    constructor(
        // private _storage: StorageServiceService
    ){
    }

    /**
     * Intercept
     *
     * @param req
     * @param next
     */
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>{
        const appclubId:string|null =  '';
        const APIKEY:string = environment.API_KEY;
        
        let newReq = req.clone();

        newReq = req.clone({
            // headers: req.headers.set('Pl-Deviceid', appclubId || '').set('Pl-Apikey', APIKEY)
        });


        /*
        if(req.method == "GET" ){


            if ( token ) {
                newReq = req.clone({
                    headers: req.headers.set('Authorization', 'Bearer ' + token)
                                        .set('Mu-Deviceid', deviceId || '')
                                        .set('Mu-Apikey', this.API_KEY),
                    params: req.params.append('language', this.language)
                });
            }else{
                newReq = req.clone({
                    headers: req.headers.set('Mu-Deviceid', deviceId || '')
                                        .set('Mu-Apikey', this.API_KEY),
                    params: req.params.append('language', this.language)
                });
            }


        }else{

            if ( token ) {
                newReq = req.clone({
                    headers: req.headers.set('Authorization', 'Bearer ' + token)
                                        .set('Mu-Deviceid', deviceId || '')
                                        .set('Mu-Apikey', this.API_KEY)
                });
            }else{
                newReq = req.clone({
                    headers: req.headers.set('Mu-Deviceid', deviceId || '')
                                        .set('Mu-Apikey', this.API_KEY)
                });
            }
        }
        */



        if(this.debug) console.log(req.method, 'REQUEST HEADERS', newReq)

        // Response
        return next.handle(newReq).pipe(
            catchError((error) => {
                console.error('Interceptor error', error);
                console.error('Interceptor error', error.error);

                if (error instanceof TimeoutError)
                    console.error('Timeout has occurred', req.url);

                // if(!newReq.url.includes('usuarios/login')){
                //     if ( error instanceof HttpErrorResponse && error.status === 401 ){
                //         localStorage.removeItem('appclublite_user_token');
                //         location.reload();

                //         return throwError(() => new Error('Sin autoriización'))
                //     }else{
                //         if(error.error.text === 'TOKEN_NOT_EXISTS'){
                //             localStorage.removeItem('appclublite_user_token');
                //             location.reload();
    
                //             return throwError(() => new Error('Sin autoriización'))
                //         }
                //     }
                // }


                //return throwError(() => new Error(error.error.text))
                //return throwError(new Error(error.error?.text || error.error?.msg || 'Error desconocido'));
                return throwError({
                    status: error.status,
                    message: error.error?.msg || error.error?.text || 'Error desconocido'
                });
                })
        );
    }
}